import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';
import { I18nContext } from 'utils/I18n/context';

const DataComponentTablePaymentAccounts = ({
    loading,
    data,
    className,
    headerNames,
    multiLevelHeaderNames,
    columnData
}) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.dataTable || {};

    const getKey = useCallback((data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    }, []);


    return (
        <div className="loading-wrapper">
            {loading && data.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="table-responsive">
                <div className="wrap__desktop">
                    <table className={`table table-data ${className}`}>
                        <Header
                            headerNames={headerNames}
                            multiLevelHeaderNames={multiLevelHeaderNames}
                            columnData={columnData.header}
                        />
                        <tbody>
                            {data.map((item, i) => {
                                let itemClassName = item.className;
                                delete item.className;
                                return (
                                    <tr key={getKey(item.id || i)} className={itemClassName}>
                                        {Object.keys(item).map((key, j) => {
                                            const data = columnData.body[j] || {};
                                            let value;

                                            if(key === 'accountInfoMobile') {
                                                return;
                                            }

                                            if (typeof item[key] === 'object') {
                                                value = item[key];
                                            } else if (typeof item[key] === 'string'){
                                                value = Parser(item[key]);
                                            }

                                            if(value === undefined) {
                                                return;
                                            }

                                            return <td className={key} key={j} {...data}>{value}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!data.length
                        ? loading
                            ? <Loading center={true} />
                            : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                        : null
                    }
                </div>
                <div className="wrap__mobile account-list">
                    {data.map((item, i) => {
                        let itemClassName = "account-item";

                        return (
                            <div className={itemClassName} key={i}>
                                {Object.keys(item).map((key, j) => {
                                    const data = columnData.body[j] || {};
                                    let value;

                                    if (typeof item[key] === 'object') {
                                        value = item[key];
                                    } else if (typeof item[key] === 'string'){
                                        value = Parser(item[key]);
                                    }

                                    if(value === undefined) {
                                        return;
                                    }

                                    return <div className={key} key={j} {...data}>{value}</div>
                                })}
                            </div>
                        )})}
                </div>
            </div>
        </div>
    );
};

DataComponentTablePaymentAccounts.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    className: PropTypes.string,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    })
};

DataComponentTablePaymentAccounts.defaultProps = {
    loading: false,
    data: [],
    className: '',
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {
        header: {},
        body: {}
    }
};

export default DataComponentTablePaymentAccounts;
